var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromiseFulfilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 54,
    viewBox: "0 0 61 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.4509C1 8.36476 7.98494 1 16.6025 1C22.6678 1 27.922 4.6497 30.5 9.98261C33.078 4.6497 38.3322 1 44.3975 1C53.0151 1 60 7.90719 60 17.4509C60 34.4628 30.5 53 30.5 53C30.5 53 1 34.4628 1 17.4509Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromiseFulfilIcon);
export default __webpack_public_path__ + "static/media/PromiseFulfilIcon.bb49d552a5420ce4ad2ac54d13434b3f.svg";
export { ForwardRef as ReactComponent };